var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.956,
    height: 16.769,
    viewBox: "0 0 23.956 16.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-side",
    "data-name": "Icon awesome-car-side",
    d: "M20.363,8.239h-.6l-4.072-5.09a2.4,2.4,0,0,0-1.871-.9H5.814A2.4,2.4,0,0,0,3.59,3.756L1.8,8.324A2.39,2.39,0,0,0,0,10.635v4.192a.6.6,0,0,0,.6.6H2.4a3.593,3.593,0,1,0,7.187,0h4.791a3.593,3.593,0,1,0,7.187,0h1.8a.6.6,0,0,0,.6-.6V11.832A3.593,3.593,0,0,0,20.363,8.239ZM5.989,17.222a1.8,1.8,0,1,1,1.8-1.8A1.8,1.8,0,0,1,5.989,17.222Zm2.7-8.983H4.377L5.814,4.646h2.87Zm1.8,0V4.646h3.34L16.7,8.239Zm7.486,8.983a1.8,1.8,0,1,1,1.8-1.8A1.8,1.8,0,0,1,17.967,17.222Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.868cb626a422779b430de3f6b94a2bb7.svg";
export { ForwardRef as ReactComponent };